import { COLORS } from '@btime/constants'
import React from 'react'

import Tag from '../../../components/presentation/Tag'

const OriginTag = ({ origin, ...props }) => {
  let color = COLORS.green
  if (origin === 'back') color = COLORS.dark1
  if (origin === 'mobile') color = COLORS.purple
  return <Tag label={origin.toUpperCase()} color={color} size="xxsmall" {...props} />
}

export default OriginTag
